import classNames from 'classnames';
import { Tooltip, TooltipProps } from 'react-tippy';
import 'react-tippy/dist/tippy.css';
import React, { useEffect, useRef } from 'react';

interface TooltipHandle {
  hideTooltip?: () => void;
}

type Props = TooltipProps & {
  disableOnScroll?: boolean;
  customClass?: string;
  color?: string;
  visible?: boolean;
  children?: React.ReactNode;
};

const PopOver: React.FC<Props> = (props) => {
  const ref = useRef<TooltipHandle | null>(null);

  const { disableOnScroll, customClass, visible = true, children, html, useContext, ...rest } = props;

  const shouldUseContext = useContext ?? React.isValidElement(html);

  useEffect(() => {
    if (disableOnScroll) {
      return undefined;
    }

    const onScroll = () => {
      ref.current?.hideTooltip?.();
    };

    window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [disableOnScroll]);

  return (
    <>
      {visible ? (
        React.createElement(
          Tooltip,
          {
            ...(rest as TooltipProps),
            html,
            ref: ref as never,
            useContext: shouldUseContext,
            className: classNames(customClass),
          },
          children
        )
      ) : (
        <>{children}</>
      )}
    </>
  );
};

export default PopOver;
